import { useEffect, useState } from "react";
import { CONST_DELAY } from "@/utils/constants/constants";

function useDebounce<T>(value: T, delay: number = CONST_DELAY): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedValue(value), delay);

    return () => {
      clearTimeout(timer);
    };
  }, [value, delay]);

  return debouncedValue;
}

export default useDebounce;
